<script setup>
import {computed, ref, watch} from "vue"
import {router, usePage} from "@inertiajs/vue3"
import {VNumberInput} from 'vuetify/labs/VNumberInput'

const page = usePage()
const props = defineProps({
    min: Number,
    max: Number,
    steps: {
        type: Number,
        default: 0
    },
})

const minParams = Number(page.props.ziggy?.query?.min);
const maxParams = Number(page.props.ziggy?.query?.max);

const range = ref(page.props.priceFilterRange || [minParams || props.min, maxParams || props.max])
const minValue = ref(minParams || props.min)
const maxValue = ref(maxParams || props.max)

watch(() => page.url, () => {
    const urlParams = new URLSearchParams(window.location.search)
    const minParam = urlParams.get('min')
    const maxParam = urlParams.get('max')

    if (minParam !== null) {
        minValue.value = Number(minParam)
    }
    if (maxParam !== null) {
        maxValue.value = Number(maxParam)
    }

    range.value = [minValue.value, maxValue.value]

}, {immediate: true})

const routeParamsClean = computed(() => {
    const params = {...route().params}
    delete params.max
    delete params.min
    delete params.page
    return params
})

const applyFilter = () => {
    const params = route().params
    delete params.page

    const maxPrice = props.max
    const minPrice = props.min

    const changeMinPrice = range.value[0]
    const changeMaxPrice = range.value[1]

    minValue.value = changeMinPrice
    maxValue.value = changeMaxPrice

    if (changeMinPrice === minPrice && changeMaxPrice !== maxPrice) {
        delete params.min
        router.get(route(route().current(), {
            ...params,
            'max': changeMaxPrice,
        }))
    } else if (changeMaxPrice === maxPrice && changeMinPrice !== minPrice) {
        delete params.max
        router.get(route(route().current(), {
            ...params,
            'min': changeMinPrice,
        }))
    } else if (changeMinPrice === minPrice && changeMaxPrice === maxPrice) {
        delete params.min
        delete params.max
        router.get(route(route().current(), params))
    } else {
        router.get(route(route().current(), {
            ...params,
            'min': changeMinPrice,
            'max': changeMaxPrice
        }))
    }
}

const changeFilterBtn = computed(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const minParam = urlParams.get('min')
    const maxParam = urlParams.get('max')

    return !(minParam !== null || maxParam !== null);
})

watch(range, (newRange) => {
    minValue.value = newRange[0]
    maxValue.value = newRange[1]
}, { deep: true })

watch([minValue, maxValue], ([newMin, newMax]) => {
    range.value = [newMin, newMax]
}, { deep: true })

</script>

<template>
    <v-sheet v-if="min !== undefined && max !== undefined" class="my-5">
        <p class="pb-2">Faixa de preço</p>
        <v-row>
            <v-col cols="12" class="pa-6">
                <v-range-slider class="pt-8" v-model="range" :min="min" :max="max" :step="1" thumb-label="always" hide-details="auto"/>
            </v-col>
            <v-col cols="12" class="py-0">
                <v-row>
                    <v-col cols="6">
                        <v-number-input
                            control-variant="hidden"
                            label="Minimo"
                            :min="min"
                            :max="max"
                            v-model="minValue"
                        ></v-number-input>
                    </v-col>
                    <v-col cols="6">
                        <v-number-input
                            control-variant="hidden"
                            label="Maximo"
                            :min="min"
                            :max="max"
                            v-model="maxValue"
                        ></v-number-input>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
                <v-row>
                    <v-col class="d-flex justify-end" v-if="changeFilterBtn">
                        <v-btn width="50%" @click="applyFilter" color="primary" text="Filtrar" class="px-2"/>
                    </v-col>
                    <v-col class="d-flex justify-end" v-else>
                        <v-btn width="50%" :href="route(route().current(), routeParamsClean)" color="secundary" text="Limpar"/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>
</template>
